import { useState } from 'react';
import { toast } from 'sonner';
import { mocApi } from '../api/client';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Archive, Trash, CircleNotch } from '@phosphor-icons/react';

export const isAdminGeneral = (user) => (user?.mocRoles || []).some((r) => (r.Role_ID || r.role_id) === 'ROLE-12');

const MODES = [
  ['archive', Archive, 'Archiver (statut « Supprimée »)', 'La MOC disparaît des listes mais reste dans Google Sheets.'],
  ['hard', Trash, 'Supprimer définitivement', 'Efface la MOC et toutes ses données liées (actions, approbations, PSSR, SiD, historique). Irréversible.'],
];

export const DeleteMocDialog = ({ moc, open, onOpenChange, onDone }) => {
  const [mode, setMode] = useState('archive');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  if (!moc) return null;

  const run = async () => {
    setBusy(true);
    const res = await mocApi.deleteMoc(moc.id, mode);
    setBusy(false);
    if (!res.ok) { toast.error(res.error || 'Suppression impossible'); return; }
    toast.success(mode === 'hard' ? `${moc.id} supprimée définitivement` : `${moc.id} archivée`);
    setConfirm(''); onOpenChange(false); onDone?.();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setConfirm(''); onOpenChange(o); }}>
      <DialogContent data-testid="delete-moc-dialog" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>Supprimer {moc.id}</DialogTitle>
          <DialogDescription>{moc.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {MODES.map(([k, Icon, label, desc]) => (
            <button key={k} type="button" data-testid={`delete-mode-${k}`} onClick={() => setMode(k)}
              className={`w-full text-left flex gap-3 p-3 rounded-sm border transition-colors ${mode === k ? (k === 'hard' ? 'border-destructive bg-destructive/5' : 'border-primary bg-primary/5') : 'border-border hover:bg-muted'}`}>
              <Icon size={20} weight="bold" className={k === 'hard' ? 'text-destructive mt-0.5' : 'text-primary mt-0.5'} />
              <div><div className="font-semibold text-sm">{label}</div><div className="text-xs text-muted-foreground">{desc}</div></div>
            </button>
          ))}
        </div>
        <div className="space-y-1.5">
          <label className="text-xs text-muted-foreground">Pour confirmer, saisissez <span className="font-mono font-semibold text-foreground">{moc.id}</span></label>
          <Input data-testid="delete-moc-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder={moc.id} />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" data-testid="delete-moc-cancel" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button variant="destructive" size="sm" data-testid="delete-moc-submit" disabled={busy || confirm.trim() !== moc.id} onClick={run}>
            {busy && <CircleNotch size={16} className="animate-spin mr-1.5" />}
            {mode === 'hard' ? 'Supprimer définitivement' : 'Archiver'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
